import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

export const ExpensesListPageLayout = ({ children }: React.PropsWithChildren) => {
  // ResponsivePage.Body's overflow:auto container breaks the
  // CSS height chain needed for the sticky SyncFooter. We render it hidden to keep
  // framework integration (error boundaries, etc.) and use a sibling Box for layout.
  return (
    <>
      <Box className="hidden">
        <ResponsivePage.Body variant="fullscreen">&nbsp;</ResponsivePage.Body>
      </Box>
      <Box height="full">{children}</Box>
    </>
  )
}
